import React, { PropsWithChildren } from 'react'
import Button from '@Components/Buttons/Button'

interface ReviewStepProps {
    header: string
    onBack(): void
    onSubmit(): void
    selectedWriterName: string
}

const ReviewStep = (props: PropsWithChildren<ReviewStepProps>) => {
    const { header, onBack, onSubmit, selectedWriterName, children } = props
    return (
        <>
            <h2>{header}</h2>
            <p>Please review the information below to confirm it's correct before submitting your request.</p>
            <div className="review-information">
                <div>
                    <p>Songwriter Name: </p>
                    <p>
                        <b>{selectedWriterName}</b>
                    </p>
                </div>
                {children}
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={onBack}>
                    Back
                </Button>
                <Button mainColor type="primary" onClick={onSubmit}>
                    Submit Request
                </Button>
            </div>
        </>
    )
}
export default ReviewStep
